@let items = (facilityOptions$ | async) ?? [];

@if (label) {
  <lib-select
    [style.height.%]="100"
    [options]="items"
    (scrolled)="loadMore()"
    [formControl]="control"
    [label]="label"
    [fullWidth]="fullWidth"
  />
} @else {
  @if (labelTranslateKey) {
    <lib-select
      [style.height.%]="100"
      [options]="items"
      (scrolled)="loadMore()"
      [formControl]="control"
      [labelTranslateKey]="labelTranslateKey"
      [fullWidth]="fullWidth"
    />
  } @else {
    <lib-select
      [style.height.%]="100"
      [options]="items"
      (scrolled)="loadMore()"
      [formControl]="control"
      [fullWidth]="fullWidth"
    />
  }
}
